import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import * as style from './DealDetailsHeader.module.less';

import { Flex } from '../../UI/Flex/Flex';
import { MetadataEntry } from './MetadataEntry/MetadataEntry';

export const DealDetailsHeader = observer(() => {
    const store = useStore();
    const query = store.query;

    if (!query) {
        return null;
    }

    const error = store.errorMessageTicker;

    const metaFields = [
        { label: 'Founded:', value: query.value('year_founded') },
        { label: 'CEO', value: query.value('company_ceo') },
        { label: 'HQ', value: query.value('hq_location') },
        { label: 'Industry', value: query.value('industry') },
        { label: 'Sub-industry', value: query.value('industrySubType') }
        //{ label: 'Last updated:', value: query.value('report_creation_date') }
    ];

    const values = [];
    metaFields.forEach((field, index) => {
        values.push(
            <MetadataEntry
                key={field.label}
                label={field.label}
                value={field.value}
            />
        );

        if (index < metaFields.length - 1) {
            values.push(
                <div
                    key={'sep_' + field.label}
                    className={style.seperatorFields}
                >
                    <i className="bi bi-dot"></i>
                </div>
            );
        }
    });

    return (
        <Flex direction="column" className={style.header}>
            <div className={style.metadataContainer}>{values}</div>
        </Flex>
    );
});
